import {Box, HStack, Text, ThemeColorPath, ThemeColorTextPath} from 'platform/foundation';
import {match} from 'ts-pattern';

import {RequiredTestIdProps} from 'shared/web';

const HIGHLIGHTED_BACKGROUND_COLOR: ThemeColorPath = 'palettes.purple.20.100';
const HIGHLIGHTED_TEXT_COLOR: ThemeColorTextPath = 'featureHighlight';
const TEXT_COLOR: ThemeColorTextPath = 'secondary';

export interface FeatureItemProps extends RequiredTestIdProps {
  title: string;
  isHighlighted?: boolean;
}

export function FeatureItem(props: FeatureItemProps) {
  const {backgroundColor, color} = match(props.isHighlighted ?? false)
    .with(true, () => ({
      backgroundColor: HIGHLIGHTED_BACKGROUND_COLOR,
      color: HIGHLIGHTED_TEXT_COLOR,
    }))
    .otherwise(() => ({backgroundColor: undefined, color: TEXT_COLOR}));

  return (
    <HStack justify="flex-start" maxWidth="100%">
      <Box
        paddingHorizontal={2}
        paddingVertical={1}
        borderRadius="small"
        backgroundColor={backgroundColor}
        maxWidth="100%"
      >
        <Text size="small" color={color} alternative data-testid={props['data-testid']}>
          {props.title}
        </Text>
      </Box>
    </HStack>
  );
}
